import React from "react";

const MoreItemsSkeleton: React.FC = () => {
  return (
    <section className="flex w-full flex-col bg-white">
      <div className="grid w-full grid-cols-1 gap-4 px-4 py-6 md:gap-6 md:px-6 md:py-8 lg:mx-auto lg:max-w-lg lg:gap-8 lg:px-3 lg:py-0 lg:pb-10">
        <h2 className="font-montserrat text-heading-4 text-neutral-600 md:text-heading-3 lg:text-heading-2">
          Recent Articles
        </h2>
        <div className="mx-auto grid w-full max-w-lg auto-rows-auto grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 [&>*:nth-child(3)]:hidden lg:[&>*:nth-child(3)]:grid">
          {[...Array(3)].map((_, index) => (
            <div
              key={index}
              className="group relative row-span-4 grid grid-cols-1 gap-2"
            >
              <div className="relative aspect-[360/180] animate-pulse bg-gray-200" />
              <div className="h-6 w-full animate-pulse rounded bg-gray-200" />
              <div className="h-4 w-full animate-pulse rounded bg-gray-200" />
              <div className="h-4 w-3/4 animate-pulse rounded bg-gray-200" />
              <div className="flex w-full flex-row justify-between">
                <div className="h-4 w-1/3 animate-pulse rounded bg-gray-200" />
                <div className="h-4 w-1/5 animate-pulse rounded bg-gray-200" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MoreItemsSkeleton;
